import { createSelector } from '@reduxjs/toolkit';
import { FDealType, FOfferType, normalizeOfferType } from '../../../../packages/JsonQuery';
import { selectDealType, selectOfferType } from 'shared/selectors/jsonQuery';

interface IOfferType {
  label: string;
  value: FOfferType;
  marker?: string;
}

interface IOfferTypeByDealType {
  dealType: FDealType;
  offerType: FOfferType;
  list: IOfferType[];
}

const OFFER_TYPES_BY_DEAL_TYPE: IOfferTypeByDealType[] = [
  {
    dealType: FDealType.Sale,
    offerType: FOfferType.Residential,
    list: [
      { label: 'Квартира в новостройке', value: FOfferType.FlatNew },
      { label: 'Квартира во вторичке', value: FOfferType.FlatOld },
      { label: 'Комната', value: FOfferType.Room },
      { label: 'Дом, дача', value: FOfferType.House },
      { label: 'Часть дома', value: FOfferType.HousePart },
      { label: 'Таунхаус', value: FOfferType.Townhouse },
      { label: 'Участок', value: FOfferType.Land },
      { label: 'Гараж', value: FOfferType.Garage },
    ],
  },

  {
    dealType: FDealType.Sale,
    offerType: FOfferType.Commercial,
    list: [
      { label: 'Офис', value: FOfferType.Office },
      { label: 'Торговая площадь', value: FOfferType.TradeArea },
      { label: 'Склад', value: FOfferType.Warehouse },
      { label: 'Помещение свободного назначения', value: FOfferType.FreeAppointmentObject },
      { label: 'Общепит', value: FOfferType.PublicCatering },
      { label: 'Производство', value: FOfferType.Manufacture },
      { label: 'Автосервис', value: FOfferType.AutoService },
      { label: 'Здание', value: FOfferType.Building },
      { label: 'Бытовые услуги', value: FOfferType.DomesticServices },
      { label: 'Коммерческая земля', value: FOfferType.CommercialLand },
    ],
  },
  {
    dealType: FDealType.RentLongterm,
    offerType: FOfferType.Residential,
    list: [
      { label: 'Квартира', value: FOfferType.FlatOld },
      { label: 'Комната', value: FOfferType.Room },
      { label: 'Койко-место', value: FOfferType.Bed },
      { label: 'Дом, дача', value: FOfferType.House },
      { label: 'Часть дома', value: FOfferType.HousePart },
      { label: 'Таунхаус', value: FOfferType.Townhouse },
      { label: 'Гараж', value: FOfferType.Garage },
    ],
  },
  {
    dealType: FDealType.RentLongterm,
    offerType: FOfferType.Commercial,
    list: [
      { label: 'Офис', value: FOfferType.Office },
      {
        label: 'Коворкинг',
        value: FOfferType.Coworking,
      },
      { label: 'Торговая площадь', value: FOfferType.TradeArea },
      { label: 'Склад', value: FOfferType.Warehouse },
      { label: 'Помещение свободного назначения', value: FOfferType.FreeAppointmentObject },
      { label: 'Общепит', value: FOfferType.PublicCatering },
      { label: 'Производство', value: FOfferType.Manufacture },
      { label: 'Автосервис', value: FOfferType.AutoService },
      { label: 'Здание', value: FOfferType.Building },
      { label: 'Бытовые услуги', value: FOfferType.DomesticServices },
      { label: 'Коммерческая земля', value: FOfferType.CommercialLand },
    ],
  },
  {
    dealType: FDealType.RentDaily,
    offerType: FOfferType.Residential,
    list: [
      { label: 'Квартира', value: FOfferType.FlatOld },
      { label: 'Комната', value: FOfferType.Room },
      { label: 'Койко-место', value: FOfferType.Bed },
      { label: 'Дом, дача', value: FOfferType.House },
      { label: 'Отели и гостиницы', value: FOfferType.Hotel },
    ],
  },
];

export const selectOfferTypeOptions = createSelector([selectDealType, selectOfferType], (dealType, offerType) => {
  const normalizedOfferType = normalizeOfferType(offerType);

  const offerTypes = OFFER_TYPES_BY_DEAL_TYPE.find(t => t.dealType === dealType && t.offerType === normalizedOfferType);

  return (offerTypes && offerTypes.list) || [];
});
